import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { getDateForDisplay } from '@components/export/spread/helpers';
import * as GC from '@grapecity/spread-sheets';
import { CanImportDeactivateGuard } from '@guards/can-import-deactivate-guard.service';
import { Globals } from '@models/globals';
import { IImportInfo, IImportSettings } from '@models/import/import-settings';
import { ImportCompleteState, ImporterState } from '@models/import/importer-state';
import { IAggregationErrors, IPollFileImport } from '@models/import/poll-file-import';
import { IImportPollRequest, IImportPollResponse } from '@models/import/start-import';
import { IRecalculationRequest } from '@models/recalculation/recalculation-request';
import { RecalculationTrigger } from '@models/recalculation/recalculation-trigger';
import { ObservationDatesService } from '@services/global/observation-dates.service';
import { ToastService } from '@services/global/toast.service';
import { ImportService } from '@services/import/import.service';
import { MenuService } from '@services/menu.service';
import { RecalculationService } from '@services/recalculation/recalculation.service';
import { getFileExtension, getHeaders, getNamesFromFileList } from '@shared/files';
import { hostStyle, spreadBackColor } from '@shared/spread/spread-settings'; 
import { BlobService } from 'angular-azure-blob-service';
import { Toast } from 'angular2-toaster';
import { BehaviorSubject, forkJoin, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { ImportDialogComponent } from '../import-dialog/import-dialog.component';
import {
  aggregationErrorsSetUpWorkbook,
  aggregationErrorsWorkbookInit,
  populateAggregationErrorsSpread
} from './aggregation-errors-spread';

let json: string[];

enum screenStates {
  preImport = 'preImport',
  sqlImport = 'sqlImport',
  pollImport = 'pollImport'
}

@Component({
  selector: 'app-import',
  templateUrl: './deposit-data-import.component.html',
  styleUrls: ['./deposit-data-import.component.scss']
})
export class DepositDataImportComponent implements OnInit {
  private readonly POLLING_TIME = 5000;
  public isMarketRate: boolean;
  private isDepositImport:boolean = false;
  public screenMode = screenStates.preImport;

  public showDrag = false;

  public fileUploaded = false;
  public fileImported = false;
  public fileAggregated = false;
  public isSQLImport = false;
  public displayErrors = 'none';
  public aggregationAvailable = false;
  public importAvailable = false;
  public import_cp_date = '';
  public import_datasets = [];
  public current_datasests = [];
  public uploadStyle = '';
  public importStyle = '';
  public aggregationStyle = '';
  public uploadCompleteStyle = '';
  public importCompleteStyle = '';
  public aggregationCompleteStyle = '';
  public marketRateDatabase: string;

  public isAzure: boolean;

  toastDismissed: Date = null;
  public cpDate = '';
  public importing = false;
  public percent = 0;
  public fileName = '';
  public imported = false;
  public errorText = '';
  private readonly Config = {
    sas: '',
    storageAccount: '',
    containerName: ''
  };

  public headers: string[][] = [];
  private importID: number;

  ///////////////////
  // Log Variables //
  //////////////////
  public importLogSelected = true;

  //////////////////////
  /// Errors Dialog ///
  ////////////////////
  public errorsDialogOpened = false;
  public importErrors: any[] = [];
  public aggregationErrors: IAggregationErrors[] = [];
  public aggregationErrorsWorkbook: GC.Spread.Sheets.Workbook;
  public aggregationErrorsWorksheet: GC.Spread.Sheets.Worksheet;
  public spreadBackColor = spreadBackColor;
  public hostStyle = hostStyle;
  private sources;

  private readonly onDestroy$ = new Subject();

  get ImporterState() {
    return ImporterState;
  }

  get importerStatus$() {
    return this.importService.importStatus;
  }

  public lastObservationDate: Date;

  get lastObservationDateDisplay() {
    if (this.lastObservationDate) {
      return getDateForDisplay(this.lastObservationDate);
    } else {
      return null;
    }
  }

  public loading = true;

  // List of files to be uploaded
  private readonly uploadQueue$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public set uploadQueue(queue: string[]) {
    this.uploadQueue$.next(queue);
  }
  public get uploadQueue() {
    return this.uploadQueue$.getValue();
  }

  private readonly importQueue$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public set importQueue(queue: string[]) {
    this.importQueue$.next(queue);
  }

  public get importQueue() {
    return this.importQueue$.getValue();
  }

  ////////////////////////////
  // Previous Import Dialog //
  ////////////////////////////

  public previousImportDialogOpened = false;
  public previousImport: IImportInfo;
  private importSettings: IImportSettings;

  constructor(
    private readonly blob: BlobService,
    private readonly canDeactivateService: CanImportDeactivateGuard,
    private readonly importService: ImportService,
    private readonly menu: MenuService,
    private readonly observationDateService: ObservationDatesService,
    private readonly recalculationService: RecalculationService,
    private readonly toastService: ToastService,
    public readonly dialogRef: MatDialogRef<ImportDialogComponent>
  ) {
    this.loading = true;
  }

  ngOnInit() {
    // Getting import settings
    this.isMarketRate = window.location.href.split('/')[window.location.href.split('/').length - 1] === 'market-rate-data';

    // @ts-ignore
    this.dialogRef.componentInstance.importSettingsPromise.then(res => {
      this.importSettings = res;
      this.Config.storageAccount = res.StorageAccount;
      this.Config.sas = res.SAS;
      this.Config.containerName = res.Container;
      this.isAzure = res.Use_Azure;
      this.marketRateDatabase = res.MarketRateDatabase;

      this.checkForPreviousImport();
      // Checking to see if there is an import in progress
      if (res.ActiveImport && res.ActiveImport.import_id > 0 && this.isMarketRate === res.ActiveImport.is_market_rate) {
        // Import in progress
        this.importService.importStatus = ImporterState.fileImporting;
        this.importID = res.ActiveImport.import_id;
        this.fileName = (res.ActiveImport.import_source || []).join(', ');

        console.log({ res, fileName: this.fileName });

        // res.ActiveImport.import_source.forEach((name, index) => {
        //   this.fileName = '';
        //   if (index < res.LastCompletedDepositImport.import_source.length - 1) {
        //     this.fileName += name += ', ';
        //   } else {
        //     this.fileName += name;
        //   }
        // });
        this.isSQLImport = res.ActiveImport.is_sql_import;
        this.initiateFileImportPolling();
        this.screenMode = screenStates.pollImport;
        this.percent = 100;
        this.uploadCompleteStyle = 'complete';
        this.uploadStyle = 'active';
        this.importStyle = 'active';
      }
    });

    this.dialogRef.componentInstance.updatedAccounts.subscribe((result: IPollFileImport) => {
      this.isSQLImport = false;
      this.fileName = null;
      this.importID = result.ImportID;

      this.fileAggregated = false;
      this.aggregationCompleteStyle = '';
      this.importStyle = ImportCompleteState.complete;
      this.importService.importStatus = ImporterState.fileAggregating;
      this.screenMode = screenStates.pollImport;
      this.percent = 100;
      this.uploadCompleteStyle = 'complete';
      this.uploadStyle = 'active';

      this.initiateFileImportPolling();
      // this.importStyle = 'active';
    });

    // Getting the last observation date
    this.observationDateService
      .getLastObservationDate()
      .toPromise()
      .then(res => {
        this.lastObservationDate = res;
      });

    this.importService.importStatusListener$.pipe(takeUntil(this.onDestroy$)).subscribe(status => {
      // this.menu.selectedMenuItemCanDeactivate(false);
      switch (status) {
        case ImporterState.fileAggregated:
          this.fileAggregated = true;
          // this.menu.selectedMenuItemCanDeactivate(true);
          break;
        case ImporterState.fileImported:
          this.fileImported = true;
          break;
        case ImporterState.fileUploaded:
          this.fileUploaded = true;
          break;
        case ImporterState.idle:
          // this.menu.selectedMenuItemCanDeactivate(true);
          break;
      }
    });
  }

  public async closeDialog() {
    if (await this.canDeactivate()) {
      this.dialogRef.componentInstance.close(null);
    }
  }

  ////////////////////
  // View Listeners //
  ///////////////////

  public onLogSwitchedClicked(value: boolean) {
    // if (!this.aggregationErrorsWorksheet || !this.aggregationErrorsWorkbook) {
    // populateAggregationErrorsSpread(this.aggregationErrorsWorksheet, this.aggregationErrors, this.sources);
    this.importLogSelected = value;
  }
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    if (this.screenMode === screenStates.preImport) {
      evt.preventDefault();
      evt.stopPropagation();
      const files = evt.dataTransfer.files;
      this.showDrag = true;
      if (files.length > 0) {
      }
    }
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    if (this.screenMode === screenStates.preImport) {
      evt.preventDefault();
      evt.stopPropagation();
      this.showDrag = false;
    }
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    if (this.screenMode === screenStates.preImport) {
      evt.preventDefault();
      evt.stopPropagation();
      const files = evt.dataTransfer.files;
      this.showDrag = false;
      this.initiateUpload(files);
    }
  }

  public workbookInit(args): void {
    this.aggregationErrorsWorkbook = aggregationErrorsWorkbookInit(args);
    this.aggregationErrorsWorksheet = this.aggregationErrorsWorkbook.getActiveSheet();
    aggregationErrorsSetUpWorkbook(this.aggregationErrorsWorkbook, this.aggregationErrorsWorksheet);
    populateAggregationErrorsSpread(this.aggregationErrorsWorksheet, this.aggregationErrors, this.sources);
  }

  public openSQLImport() {
    this.screenMode = screenStates.sqlImport;
  }

  public openPreImport() {
    this.screenMode = screenStates.preImport;
  }

  public fileSelectChange(fileInput: any) {
    const files = fileInput.target.files;
    this.initiateUpload(files);
  }

  public initiateSQLImport() {
    this.importService
      .initiateSqlImport(this.marketRateDatabase)
      .then(res => {
        this.isSQLImport = true;
        this.fileName = this.importSettings.MarketRateDatabase;
        this.importID = res.ImportID;
        this.screenMode = screenStates.pollImport;

        this.fileUploaded = true;
        this.uploadCompleteStyle = ImportCompleteState.complete;

        this.fileImported = true;
        this.importCompleteStyle = ImportCompleteState.complete;

        this.importService.importStatus = ImporterState.fileAggregating;
        this.aggregationStyle = ImportCompleteState.running;

        this.fileAggregated = false;
        this.initiateAggregationPolling();
      })
      .catch(err => {
        console.error(err);
        const errorToast: Toast = {
          title: 'Error Performing SQL Import',
          body: '',
          type: 'error',
          showCloseButton: true
        };
        this.toastService.showToast(errorToast);
      });
  }

  private async initiateUpload(files: FileList) {
    this.reset();
    this.isDepositImport = !this.isMarketRate;
    // Getting the names
    const names = getNamesFromFileList(files);
    // names.forEach((name, index) => {
    //   if (index + 1 !== names.length) {
    //     this.fileName += name += ', ';
    //   } else {
    //     this.fileName += name;
    //   }
    // });
    this.fileName = names.join(', ');

    this.importService.importStatus = ImporterState.fileUploading;
    this.showDrag = false;

    // Ensuring we have the correct file extension
    let fileExtensionIsCSV = true;
    for (let i = 0; i < names.length; i++) {
      const fileName = names[i];
      if (getFileExtension(fileName).toLowerCase() !== '.csv') {
        fileExtensionIsCSV = false;
        break;
      }
    }

    if (fileExtensionIsCSV) {
      this.uploadStyle = ImportCompleteState.running;
      this.screenMode = screenStates.pollImport;
      // Check for missing header
      const missingHeadersList = [];
      const errorHeaderList = [];
      // No way to check for missing headers on market rates
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.headers.push(await getHeaders(file));

        const missingHeaders = this.getMissingHeaders(this.headers[this.headers.length - 1]);
        if (missingHeaders && missingHeaders.length > 0) {
          missingHeadersList.push({ fileName: file.name, missingHeaders: missingHeaders });
        }
        if (!this.isMarketRate) {
          const errorHeaders = this.getErrorHeaders(this.headers[this.headers.length - 1]);
          if (errorHeaders && errorHeaders.length > 0) {
            errorHeaderList.push({ fileName: file.name, errorHeaders: errorHeaders });
          }
        }
      }

      if (missingHeadersList && missingHeadersList.length === 0) {
        if (errorHeaderList && errorHeaderList.length === 0) {
          // Uncomment next line to enable front-end CSV cleaning (~8 secs for 1 million rows)
          // const trimmedFiles = await forkJoin(Array.from(files).map(removeEmptyLinesFromCSV)).toPromise();

          if (this.isAzure) {
            if (files.length > 1) {
              this.uploadMultipleFilesToAzure(files);
            } else {
              // Single File Upload
              this.uploadSingleFileToAzure(files);
            }
          } else {
            this.processLocalFile(files);
          }
        } else {
          let error = `Invalid Header Characters in the following Files :  `;
          errorHeaderList.forEach(header => {
            // console.log(header);
            error += '\n' + header.fileName + '[';
            header.errorHeaders.forEach(val => {
              error += val + ',';
            });
            error = error.substring(0, error.length - 1);
            error += ']';
          });

          Swal.fire('Invalid Characters in Headers', error, 'error');
          this.reset();
          this.screenMode = screenStates.preImport;
        }
      } else {
        // Incorrect Headers in file
        if (this.isMarketRate) {
          Swal.fire(
            'EffectiveDate Field Missing',
            `Effective Date is not the first column in : ${missingHeadersList.map(({ fileName }) => (fileName += ' '))} `,
            'error'
          );
        } else {
          Swal.fire('Invalid Headers', `Invalid Headers in: ${missingHeadersList.map(({ fileName }) => (fileName += ' '))} `, 'error');
        }
        this.reset();
        this.screenMode = screenStates.preImport;
      }
    } else {
      const incorrectFormatToast: Toast = {
        title: 'File in incorrect format',
        body: 'The selected file type can only be .csv',
        type: 'error',
        showCloseButton: true
      };
      this.toastService.showToast(incorrectFormatToast);
      this.reset();
    }
  }

  private processLocalFile(files: FileList | File[]) {
    const fileSub = [];
    for (const file of Array.from(files)) {
      const reader = new FileReader();
      let headers: string[];
      reader.onload = () => {
        const csv = reader.result as string; // the entire file
        const allTextLines = csv.split('\n');
        headers = allTextLines[0].split(',').map(h => h.trim()); // use the console for debugging
        headers.forEach(header => {
          header = header.replace(/(\r\n|\n|\r)/gm, '');
        });
        json = headers;
      };

      reader.readAsText(file, 'UTF-8');
      this.importQueue.push(file.name);
      fileSub.push(this.importService.initiateLocalImport(file, file.name));
    }
    forkJoin(fileSub).subscribe(
      res => this.onFileUploadSuccess(),
      err => this.onFileUploadFailure(err)
    );
  }

  private getMissingHeaders(headers: string[]): string[] {
    const res = [];
    if (!this.isMarketRate) {
      const correctHeaders = ['AccountID', 'SubProductID', 'EOPBook', 'CurrCoupon', 'OpenDate', 'EOPDate'];

      headers = headers.map(header => header.trim());
      correctHeaders.forEach(correctHeader => {
        if (!headers.find(header => correctHeader === header)) {
          res.push(correctHeader);
        }
      });
    } else {
      if (headers[0].toLocaleUpperCase() !== 'EFFECTIVEDATE') {
        res.push('EffectiveDate');
      }
    }
    return res;
  }

  private getErrorHeaders(headers: string[]): string[] {
    const res = [];
    const reg: RegExp = /([.%^&`'!\\{}()~-])\w+/g;
    headers.forEach(head => {
      if (reg.test(head) || head.includes(' ')) {
        res.push(head);
      }
    });
    return res;
  }

  private reset() {
    this.percent = 0;
    this.importService.importStatus = ImporterState.idle;
    this.importCompleteStyle = '';
    this.importErrors = [];
    this.aggregationCompleteStyle = '';
    this.aggregationErrors = [];
    this.uploadCompleteStyle = '';
    this.uploadStyle = '';
    this.importStyle = '';
    this.aggregationStyle = '';
    this.isSQLImport = false;
    this.fileAggregated = false;
    // this.step = 1;
    this.headers = [];
    this.uploadQueue = [];
    this.importQueue = [];
    this.fileName = '';
  }

  private uploadMultipleFilesToAzure(files: FileList | File[]) {
    if (files) {
      this.uploadQueue = getNamesFromFileList(files);
      const urls = this.uploadQueue.map(fileName => this.blob.generateBlobUrl(this.Config, fileName));
      const configs = urls.map((url, ind) => {
        return {
          baseUrl: url,
          sasToken: this.Config.sas,
          blockSize: 10240 * 1024, // OPTIONAL, default value is 1024 * 32
          file: files[ind],
          complete: () => {
            // File Upload Complete
            // Removing Files from upload queue
            // this.uploadQueue = this.uploadQueue.shift();
            this.importQueue.push(this.uploadQueue.shift());
            this.uploadQueue = this.uploadQueue;
          },
          error: err => {
            Globals.importUpload = false;
            console.error(' Error Uploading file ', err);
            const toast: Toast = {
              type: 'error',
              title: 'Upload Failed',
              body: '',
              showCloseButton: true,
              toastId: 'error_uploading_toast'
            };
            this.toastService.hideToast('error_uploading_toast');
            this.toastService.showToast(toast);
            this.uploadCompleteStyle = ImportCompleteState.fail;
            this.uploadStyle = null;
            this.importService.importStatus = ImporterState.fileUploaded;
          },
          progress: percent => {
            this.percent = percent;
          }
        };
      });

      this.uploadQueue$.pipe(take(this.uploadQueue.length + 1)).subscribe(queue => {
        if (queue.length === 0) {
          // Start the import
          this.onFileUploadSuccess();
        }
      });
      Globals.importUpload = true;
      configs.forEach(config => this.blob.upload(config));
    }
  }

  private uploadSingleFileToAzure(files: FileList | File[]) {
    // Upload File List
    if (files) {
      const currentFile = files[0];
      this.importQueue = [currentFile.name];
      if (currentFile !== null) {
        const baseUrl = this.blob.generateBlobUrl(this.Config, currentFile.name);
        const config = {
          baseUrl: baseUrl,
          sasToken: this.Config.sas,
          blockSize: 10240 * 1024, // OPTIONAL, default value is 1024 * 32
          file: currentFile,
          complete: () => this.onFileUploadSuccess(),
          error: err => this.onFileUploadFailure(err),
          progress: percent => {
            this.percent = percent;
          }
        };
        Globals.importUpload = true;
        this.blob.upload(config);
      }
    }
  }

  private onFileUploadFailure(err: any) {
    console.warn('Error:', err);
    Globals.importUpload = false;
    const toast: Toast = {
      title: 'Failed To Upload File',
      body: '',
      type: 'error',
      showCloseButton: true
    };
    this.toastService.showToast(toast);
    this.importService.importStatus = ImporterState.fileUploaded;
    this.uploadCompleteStyle = ImportCompleteState.fail;
    this.uploadStyle = null;
  }

  private onFileUploadSuccess() {
    this.uploadStyle = null;
    this.percent = 100;
    this.importService.importStatus = ImporterState.fileUploaded;
    this.uploadCompleteStyle = ImportCompleteState.complete;
    Globals.importUpload = false;
    // const toast: Toast = {
    //   title: 'Upload Successful',
    //   body: '',
    //   type: 'success',
    //   showCloseButton: true
    // };
    // this.notificationService.showToast(toast);

    if (this.importQueue.length > 1) {
      this.initiateFileImportList();
    } else {
      this.initiateFileImport();
    }
  }

  private initiateFileImportList() {
    // Next step initiate file import
    this.importService.importStatus = ImporterState.fileImporting;
    // this.step = 2;
    this.importStyle = ImportCompleteState.running;

    const importRequests = this.importQueue.map((fileName, index) => {
      return {
        FileName: fileName,
        Headers: this.headers[index],
        ImportID: -1,
        ImportSource: null,
        IsExcel: false,
        IsMarketRate: this.isMarketRate,
        selectedSheets: []
      };
    });

    this.importService
      .initiateFileImportList(importRequests)
      .then((res: IImportPollResponse) => {
        if (res.ImportID) {
          this.importID = res.ImportID;
          this.initiateFileImportPolling();
        }
      })
      .catch(err => {
        console.error(err);
        // Display Error Toast
        // this.getStepStyle(true);
        this.importService.importStatus = ImporterState.idle;
        this.importCompleteStyle = 'fail';
      });
  }

  private initiateFileImport() {
    // Next step initiate file import
    this.importService.importStatus = ImporterState.fileImporting;
    // this.step = 2;
    this.importStyle = ImportCompleteState.running;

    const importRequest: IImportPollRequest = {
      FileName: this.importQueue[0],
      Headers: this.headers[0],
      ImportID: -1,
      ImportSource: null,
      IsExcel: false,
      IsMarketRate: this.isMarketRate,
      selectedSheets: []
    };

    this.importService
      .initiateFileImport(importRequest)
      .then((res: IImportPollResponse) => {
        if (res.ImportID) {
          this.importID = res.ImportID;
          this.initiateFileImportPolling();
        }
      })
      .catch(err => {
        console.error(err);
        // Display Error Toast
        // this.getStepStyle(true);
        this.importService.importStatus = ImporterState.idle;
        this.importCompleteStyle = 'fail';
      });
  }

  private initiateFileImportPolling() {
    this.importService.pollFileImport(this.importID).then(pollResponse => {
      this.importErrors = pollResponse.ImportLogs;
      this.sources = this.fileName;
      this.aggregationErrors = pollResponse.AggregationErrors;
      if (pollResponse.Finish_Time || pollResponse.Success) {
        this.importStyle = null;
        if (pollResponse.Success) {
          // Once the import step is done we need to start aggregation polling
          this.fileUploaded = true;
          this.uploadCompleteStyle = ImportCompleteState.complete;

          this.fileImported = true;
          this.importCompleteStyle = this.importErrors.join().includes('Conflicts')
            ? ImportCompleteState.completeConflicts
            : ImportCompleteState.complete;

          this.initiateAggregationPolling();
        } else {
          // Import step failed
          this.importCompleteStyle = ImportCompleteState.fail;
          this.importService.importStatus = ImporterState.idle;
        }
      } else {
        // Just going to check for some kind of error in the polling
        if (this.importID !== pollResponse.ImportID) {
          this.importService.importStatus = ImporterState.idle;
          this.importCompleteStyle = ImportCompleteState.fail;
          this.dialogRef.componentInstance.importSettingsPromise = this.importService.getImportSettings();
          this.checkForPreviousImport();
          return;
        }
        setTimeout(() => this.initiateFileImportPolling(), this.POLLING_TIME);
      }
    });
  }

  private initiateAggregationPolling() {
    // this.step = 3;

    this.importService.importStatus = ImporterState.fileAggregating;
    this.aggregationStyle = ImportCompleteState.running;

    this.importService.pollAggregationImport(this.importID).then(pollResponse => {
      // Extract Logs
      this.aggregationErrors = pollResponse.AggregationErrors;
      this.importErrors = pollResponse.ImportLogs;
      this.sources = this.fileName;

      // If were running a SQL import set the filename as the table name
      if (this.isSQLImport) {
        this.fileName = this.importSettings.MarketRateDatabase;
      }

      if (pollResponse.Finish_Time || pollResponse.Success) {
        if (pollResponse.Success) {
          // Import passed
          this.aggregationCompleteStyle = ImportCompleteState.complete;
          this.aggregationStyle = null;
          this.importService.importStatus = ImporterState.fileAggregated;
          this.dialogRef.componentInstance.continueButtonDisabled = false;
          this.fileAggregated = true;

          // start recalc here <14411>
          if (!this.isMarketRate && !this.isDepositImport) {
            this.StartRecalculationAfterCharacteristicsUpdate();
          }

          this.dialogRef.componentInstance.importSettingsPromise = this.importService.getImportSettings();
          this.checkForPreviousImport();
        } else {
          // Import Failed
          this.aggregationCompleteStyle = ImportCompleteState.fail;
          this.importService.importStatus = ImporterState.fileAggregated;
          this.aggregationStyle = null;
          this.dialogRef.componentInstance.importSettingsPromise = this.importService.getImportSettings();
          this.checkForPreviousImport();
        }
      } else {
        // Restart Poll
        setTimeout(() => this.initiateAggregationPolling(), this.POLLING_TIME);
      }
    });
  }

  private async StartRecalculationAfterCharacteristicsUpdate() {
    const request: IRecalculationRequest = {
      ProductIds: [],
      RecalculationTrigger: RecalculationTrigger.AccountCharacteristicsUpdate
    };
    return await this.recalculationService.startCalculation(request).toPromise();
  }

  public async canDeactivate() {
    const canDeactivate = this.importService.importStatus === ImporterState.fileUploading;
    if (!canDeactivate) {
      const userResponse = await this.canDeactivateService.canDeactivatePopupTab().catch(err => {
        console.error('Error displaying can deactivate message', err);
      });

      return userResponse;
    }
    return false;
  }

  public togglePreviousImportDialog() {
    this.previousImportDialogOpened = !this.previousImportDialogOpened;

    this.menu.emitResize();

    if (this.isMarketRate) {
      this.previousImport = this.importSettings.LastCompletedRateImport;
      this.importErrors = this.importSettings.LastCompletedRateImport.ImportLogs;
    } else {
      this.previousImport = this.importSettings.LastCompletedDepositImport;
      this.importErrors = this.importSettings.LastCompletedDepositImport.ImportLogs;
    }
  }

  public toggleErrorsDialog(showImportErrors = false) {
    // if (this.aggregationErrorsWorksheet && showImportErrors) {
    //   populateAggregationErrorsSpread(this.aggregationErrorsWorksheet, this.aggregationErrors, this.sources);
    // }

    this.errorsDialogOpened = !this.errorsDialogOpened;

    if (showImportErrors) {
      this.onLogSwitchedClicked(showImportErrors);
      this.menu.emitResize();
    }
  }
  private checkForPreviousImport() {
    this.dialogRef.componentInstance.importSettingsPromise.then(res => {
      // Checking to see if there is a previous import
      if (this.isMarketRate && res.LastCompletedRateImport) {
        this.previousImport = res.LastCompletedRateImport;
        this.importErrors = res.LastCompletedRateImport.ImportLogs;
        this.aggregationErrors = res.LastCompletedRateImport.ImportErrors;
        this.sources = res.LastCompletedRateImport.import_source;
      } else if (!this.isMarketRate && res.LastCompletedDepositImport) {
        this.previousImport = res.LastCompletedDepositImport;
        this.importErrors = res.LastCompletedDepositImport.ImportLogs;
        this.aggregationErrors = res.LastCompletedDepositImport.ImportErrors;
        this.sources = res.LastCompletedDepositImport.import_source;
      }
    });
  }
}
